module.exports = __webpack_public_path__ + "static/img/otLogohf.f23e338.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productStage/otLogohf.png
// module id = A7zn
// module chunks = 44